import env              from '../env';
import { fetchJSON }    from '@statflo/fetch';
import { getSession }   from './SessionService';

/**
 * Send a json object containing last read message id to update the existing messages as 'read'
 * @param {string} sessionId the user's session ID
 * @param {number} lastReadMessageId the latest message that can be considered 'read' by the user
 */
export default async function updateLastReadMessage(conversationId: string, lastReadMessageId: string) {
    const session = await getSession();
    const requestInit: RequestInit = {
        method: 'PUT',
        headers: new Headers({
            'X-Session-ID': session.sid,
            'Content-Type': 'application/json'
        }),
        mode: 'cors',
        cache: 'default',
        body: `{ "last_read_message_id": ${lastReadMessageId} }`
    };

    return fetchJSON(`${env.COMMCONTROLLER_HOST}/v1/rest/conversations/${conversationId}`, requestInit);
}



// WEBPACK FOOTER //
// ./src/services/UnreadCountService.ts